import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inline-flex rounded border border-neutral-300" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonFilter',
  props: /*@__PURE__*/_mergeModels({
    options: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["change"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel<FilterOption[] | null>(__props, "modelValue")
const emit = __emit;
const props = __props;

function handleClick(option: FilterOption) {
  if (model.value === null || model.value[0].id !== option.id) {
    model.value = [option]
  } else {
    model.value = null
  }
  emit("change", model.value);
}

function isSelected(option: FilterOption) {
  return model.value !== null && model.value[0].id == option.id;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _withModifiers(($event: any) => (handleClick(option)), ["prevent"]),
            class: _normalizeClass(["relative py-2 px-4 -my-px -mx-px rounded transition", isSelected(option) ? 'bg-teal text-white' : 'hover:bg-neutral-200'])
          }, _toDisplayString(option.title), 11, _hoisted_3),
          _withDirectives(_createElementVNode("div", _hoisted_4, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "w-px h-6 bg-neutral-300" }, null, -1)
          ]), 512), [
            [_vShow, index < _ctx.options.length - 1]
          ])
        ])
      ]))
    }), 256))
  ]))
}
}

})